import React, { useState } from "react";
import { DatePicker, Table } from "antd";
import moment from "moment";
import StepProgressBar from "../../components/StepProgressBar/StepProgressBar";
import { BonusSummary } from "./UserData";

import { ReactComponent as Arrow } from "../../images/arrow.svg";
import { ReactComponent as FavoriteIcon } from "../../images/favorite.svg";
import { ReactComponent as UnFavoriteIcon } from "../../images/unfavorite.svg";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import SwitchButton from "../../components/SwitchButton/SwitchButton";
const FilterDateFormat = "YYYY-MM-DD";
const DisplayFormat = "DD MMM YYYY";

moment.locale("en-gb", {
  week: {
    dow: 1, /// Date offset
  },
});

const AllDealers = (props) => {
  const {
    bonusSummary,
    bonusSummaryFilters,
    setbonusSummaryFilters,
    UpdateFavouriteStatus,
    GetBonusSummaryDetail,
  } = props;
  const [isShowBar, setIsShowBar] = useState(true);
  const [selectedWeek, setSelectedWeek] = useState(moment().startOf("week"));
  const [selectedMonth, setSelectedMonth] = useState(moment().startOf("month"));
  const [selectedQuarter, setSelectedQuarter] = useState(moment().quarter());
  const [selectedYear, setSelectedYear] = useState(moment().startOf("year"));
  const [openDatePicker, setOpenDatePicker] = useState({
    weekly: false,
    monthly: false,
    quaterly: false,
    yearly: false,
  });

  const handleSwitch = (newState) => {
    setIsShowBar(newState);
  };

  const FormatFilterDate = (dateValue, type, format) => {
    if (dateValue !== undefined) {
      if (type === "week") {
        if (dateValue?.length < 10) {
          const FormattedDate = `${dateValue?.slice(0, 4)}-${Number(dateValue?.slice(5, 7))}th`;
          console.log("WEEK FOMART", dateValue, FormattedDate)

          const startDate = moment(FormattedDate, "YYYY-WW").startOf(type);
          const endDate = moment(FormattedDate, "YYYY-WW").endOf(type);
          return {
            startDate: startDate.format(format),
            endDate: endDate.format(format),
          };
        } else {
          const startDate = moment(dateValue, "YYYY-WW").startOf(type);
          const endDate = moment(dateValue, "YYYY-WW").endOf(type);
          return {
            startDate: startDate.format(format),
            endDate: endDate.format(format),
          };
        }
      } else if (type === "quarter") {
        const startDate = moment().quarter(dateValue).startOf("quarter");
        const endDate = moment().quarter(dateValue).endOf("quarter");
        return {
          startDate: startDate.format(format),
          endDate: endDate.format(format),
        };
      } else {
        const startDate = moment(dateValue).startOf(type);
        const endDate = moment(dateValue).endOf(type);
        return {
          startDate: startDate.format(format),
          endDate: endDate.format(format),
        };
      }
    }
    return "";
  };

  console.log("selectedWeek", selectedWeek);

  const handleWeekChange = (date, dateString) => {
    console.log("DATE STRING", dateString, date);
    if (date !== null && date !== undefined) {
      setSelectedWeek(dateString);
      setbonusSummaryFilters({
        ...bonusSummaryFilters,
        weekly: FormatFilterDate(dateString, "week", FilterDateFormat),
      });
    } else {
      setSelectedWeek(moment().startOf("week"));
      setbonusSummaryFilters({
        ...bonusSummaryFilters,
        weekly: FormatFilterDate(moment(), "week", FilterDateFormat),
      });
    }
  };

  const handleMonthChange = (date, dateString) => {
    if (date !== null && date !== "") {
      setSelectedMonth(dateString);
      setbonusSummaryFilters({
        ...bonusSummaryFilters,
        monthly: FormatFilterDate(dateString, "month", FilterDateFormat),
      });
    } else {
      setSelectedMonth(moment().startOf("month"));
      setbonusSummaryFilters({
        ...bonusSummaryFilters,
        monthly: FormatFilterDate(moment(), "month", FilterDateFormat),
      });
    }
  };

  const handleQuarterChange = (date, dateString) => {
    if (date !== null && date !== "") {
      setSelectedQuarter(dateString.charAt(dateString.length - 1));
      setbonusSummaryFilters({
        ...bonusSummaryFilters,
        quaterly: FormatFilterDate(
          dateString.charAt(dateString.length - 1),
          "quarter",
          FilterDateFormat,
          date
        ),
      });
    } else {
      setSelectedQuarter(moment().quarter());
      setbonusSummaryFilters({
        ...bonusSummaryFilters,
        quaterly: FormatFilterDate(
          moment().quarter(),
          "quarter",
          FilterDateFormat,
          date
        ),
      });
    }
  };

  const handleYearChange = (date, dateString) => {
    if (date !== null && date !== "") {
      setSelectedYear(dateString);
      setbonusSummaryFilters({
        ...bonusSummaryFilters,
        yearly: FormatFilterDate(dateString, "year", FilterDateFormat),
      });
    } else {
      setSelectedYear(moment());
      setbonusSummaryFilters({
        ...bonusSummaryFilters,
        yearly: FormatFilterDate(moment(), "year", FilterDateFormat),
      });
    }
  };

  console.log("bonusSummaryFilters", bonusSummaryFilters);

  const columns = [
    {
      title: null,
      children: [
        {
          title: "Dealer Name",
          dataIndex: "name",
          key: "name",
          width: 180,
          fixed: "left",
          render: (_, record) => (
            <div
              className="table_name_block cursor-pointer"
              onClick={() => GetBonusSummaryDetail(record?.summary_id)}
            >
              <div className="agent-logo">
                <img
                  src={`https://api.ohhto.com/${record?.icon}`}
                  alt="Dealer Logo"
                  width={30}
                  height={30}
                />
              </div>
              <p>{record.name}</p>
            </div>
          ),
        },
      ],
    },
    {
      title: "Calendar Week",
      dataIndex: "periodicalData",
      key: "periodicalData",
      filterDropdown: () => (
        <DatePicker.WeekPicker
          open={openDatePicker?.weekly}
          onOpenChange={(open) =>
            setOpenDatePicker({
              ...openDatePicker,
              weekly: open,
            })
          }
          onChange={handleWeekChange}
        />
      ),
      filterIcon: (filtered) => {
        return (
          <div
            className="table_date_block"
            onClick={() => {
              setOpenDatePicker({
                ...openDatePicker,
                weekly: !openDatePicker?.weekly,
              });
            }}
          >
            <h5>
              {`${FormatFilterDate(selectedWeek, "week", DisplayFormat)?.startDate
                } - ${FormatFilterDate(selectedWeek, "week", DisplayFormat)?.endDate
                }`}
            </h5>
            <Arrow />
          </div>
        );
      },
      children: [
        {
          title: (
            <div className="flex justify-between">
              <span>Total Loan Amt</span>
              <span>Cases</span>
            </div>
          ),
          dataIndex: "week_loan_amt",
          key: "week_loan_amt",
          width: 255,
          render: (_, record) => {
            console.log("record", record);
            const CurrentData = record.periodicalData
              ?.filter((it) => it.value === "weekly")
              .pop();
            return (
              <>
                <div
                  className="bonus_cases_block"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    GetBonusSummaryDetail(record?.summary_id, "weekly")
                  }
                >
                  <div>
                    <h4>${CurrentData?.achieved_amount}</h4>
                    <h5>Bonus Amt: ${CurrentData?.bonus_amount}</h5>
                  </div>
                  <h6>{CurrentData?.no_of_applications}</h6>
                </div>
                {isShowBar && (
                  <StepProgressBar
                    achievedValue={CurrentData?.achieved_amount}
                    // targetValue={CurrentData?.total_amount}
                    targetValue={parseFloat(
                      CurrentData?.stepData[CurrentData?.stepData.length - 1]
                        ?.value
                    )}
                    currentStep={0}
                    stepData={CurrentData?.stepData}
                  />
                )}
              </>
            );
          },
        },
      ],
    },
    {
      title: "Calendar Month",
      dataIndex: "periodicalData",
      key: "periodicalData",
      filterDropdown: () => (
        <DatePicker.MonthPicker
          open={openDatePicker?.monthly}
          onOpenChange={(open) =>
            setOpenDatePicker({
              ...openDatePicker,
              monthly: open,
            })
          }
          onChange={handleMonthChange}
        />
      ),
      filterIcon: (filtered) => {
        return (
          <div
            className="table_date_block"
            onClick={() => {
              setOpenDatePicker({
                ...openDatePicker,
                monthly: !openDatePicker?.monthly,
              });
            }}
          >
            <h5>
              {" "}
              {`${FormatFilterDate(selectedMonth, "month", DisplayFormat)
                ?.startDate
                } - ${FormatFilterDate(selectedMonth, "month", DisplayFormat)?.endDate
                }`}
            </h5>
            <Arrow />
          </div>
        );
      },
      children: [
        {
          title: (
            <div className="flex justify-between">
              <span>Total Loan Amt</span>
              <span>Cases</span>
            </div>
          ),
          dataIndex: "month_loan_amt",
          key: "month_loan_amt",
          width: 255,
          render: (_, record) => {
            const CurrentData = record.periodicalData
              ?.filter((it) => it.value === "monthly")
              .pop();
            return (
              <>
                <div
                  className="bonus_cases_block"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    GetBonusSummaryDetail(record?.summary_id, "monthly")
                  }
                >
                  <div>
                    <h4>${CurrentData?.achieved_amount}</h4>
                    <h5>Bonus Amt: ${CurrentData?.bonus_amount}</h5>
                  </div>
                  <h6>{CurrentData?.no_of_applications}</h6>
                </div>
                {isShowBar && (
                  <StepProgressBar
                    achievedValue={CurrentData?.achieved_amount}
                    targetValue={parseFloat(
                      CurrentData?.stepData[CurrentData?.stepData.length - 1]
                        ?.value
                    )}
                    currentStep={0}
                    stepData={CurrentData?.stepData}
                  />
                )}
              </>
            );
          },
        },
      ],
    },
    {
      title: "Calendar Quarter",
      dataIndex: "currentQuarter",
      key: "currentQuarter",
      filterDropdown: () => (
        <DatePicker.QuarterPicker
          open={openDatePicker?.quaterly}
          onOpenChange={(open) =>
            setOpenDatePicker({
              ...openDatePicker,
              quaterly: open,
            })
          }
          onChange={handleQuarterChange}
        />
      ),
      filterIcon: (filtered) => {
        return (
          <div
            className="table_date_block"
            onClick={() => {
              setOpenDatePicker({
                ...openDatePicker,
                quaterly: !openDatePicker?.quaterly,
              });
            }}
          >
            <h5>{`${FormatFilterDate(selectedQuarter, "quarter", DisplayFormat)
              ?.startDate
              } - ${FormatFilterDate(selectedQuarter, "quarter", DisplayFormat)
                ?.endDate
              }`}</h5>
            <Arrow />
          </div>
        );
      },
      children: [
        {
          title: (
            <div className="flex justify-between">
              <span>Total Loan Amt</span>
              <span>Cases</span>
            </div>
          ),
          dataIndex: "quarter_loan_amt",
          key: "quarter_loan_amt",
          width: 255,
          render: (_, record) => {
            const CurrentData = record.periodicalData
              ?.filter((it) => it.value === "quarterly")
              .pop();
            return (
              <>
                <div
                  className="bonus_cases_block"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    GetBonusSummaryDetail(record?.summary_id, "quarterly")
                  }
                >
                  <div>
                    <h4>${CurrentData?.achieved_amount}</h4>
                    <h5>Bonus Amt: ${CurrentData?.bonus_amount}</h5>
                  </div>
                  <h6>{CurrentData?.no_of_applications}</h6>
                </div>
                {isShowBar && (
                  <StepProgressBar
                    achievedValue={CurrentData?.achieved_amount}
                    targetValue={parseFloat(
                      CurrentData?.stepData[CurrentData?.stepData.length - 1]
                        ?.value
                    )}
                    currentStep={0}
                    stepData={CurrentData?.stepData}
                  />
                )}
              </>
            );
          },
        },
      ],
    },
    {
      title: "Calendar Year",
      dataIndex: "currentYear",
      key: "currentYear",
      filterDropdown: () => (
        <DatePicker.YearPicker
          open={openDatePicker?.yearly}
          onOpenChange={(open) =>
            setOpenDatePicker({
              ...openDatePicker,
              yearly: open,
            })
          }
          onChange={handleYearChange}
        />
      ),
      filterIcon: (filtered) => {
        return (
          <div
            className="table_date_block"
            onClick={() => {
              setOpenDatePicker({
                ...openDatePicker,
                yearly: !openDatePicker?.yearly,
              });
            }}
          >
            <h5>{`${FormatFilterDate(selectedYear, "year", DisplayFormat)?.startDate
              } - ${FormatFilterDate(selectedYear, "year", DisplayFormat)?.endDate
              }`}</h5>
            <Arrow />
          </div>
        );
      },
      children: [
        {
          title: (
            <div className="flex justify-between">
              <span>Total Loan Amt</span>
              <span>Cases</span>
            </div>
          ),
          dataIndex: "year_loan_amt",
          key: "year_loan_amt",
          width: 255,
          render: (_, record) => {
            const CurrentData = record.periodicalData
              ?.filter((it) => it.value === "yearly")
              .pop();
            return (
              <>
                <div
                  className="bonus_cases_block"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    GetBonusSummaryDetail(record?.summary_id, "yearly")
                  }
                >
                  <div>
                    <h4>${CurrentData?.achieved_amount}</h4>
                    <h5>Bonus Amt: ${CurrentData?.bonus_amount}</h5>
                  </div>
                  <h6>{CurrentData?.no_of_applications}</h6>
                </div>
                {isShowBar && (
                  <StepProgressBar
                    achievedValue={CurrentData?.achieved_amount}
                    targetValue={CurrentData?.total_amount}
                    currentStep={0}
                    stepData={CurrentData?.stepData}
                  />
                )}
              </>
            );
          },
        },
      ],
    },
    {
      title: null,
      children: [
        {
          title: "Action",
          dataIndex: "action",
          key: "action",
          width: 100,
          render: (_, record, index) => (
            <div className="action-tab-block">
              <div className="table_fav">
                {console.log("RESCORD", record)}
                <div
                  className="table_fav_icon"
                  onClick={() =>
                    UpdateFavouriteStatus(
                      record?.summary_id,
                      record?.is_favourite == 1 ? 0 : 1
                    )
                  }
                >
                  {record?.is_favourite == 1 ? (
                    <FavoriteIcon />
                  ) : (
                    <UnFavoriteIcon />
                  )}
                </div>
              </div>
              {/* <SwitchButton
                initialState={isShowBar}
                onSwitch={handleSwitch}
                leftLabel="Off"
                rightLabel="On"
              /> */}
            </div>
          ),
        },
      ],
    },
  ];

  const data = bonusSummary;

  return (
    <section className="table_section">
      <Table
        columns={columns}
        dataSource={data}
        bordered={false}
        size="middle"
        scroll={{ x: "calc(700px + 50%)" }}
        className="custom_table_section"
      />
    </section>
  );
};

export default AllDealers;
